interface AnalyticsEvent {
  type: string;
  data: Record<string, unknown>;
  timestamp: string;
}

const events: AnalyticsEvent[] = [];

export function trackEvent(type: string, data: Record<string, unknown> = {}) {
  const event: AnalyticsEvent = {
    type,
    data,
    timestamp: new Date().toISOString(),
  };

  events.push(event);

  const storedEvents = localStorage.getItem('optiaiAnalytics');
  const allEvents = storedEvents ? JSON.parse(storedEvents) : [];
  allEvents.push(event);

  localStorage.setItem('optiaiAnalytics', JSON.stringify(allEvents));

  console.log('[Analytics]', type, data);
}

export function trackPageView(page: string) {
  trackEvent('page_view', { page });
}

export function trackCTAClick(cta: string, location: string) {
  trackEvent('cta_click', { cta, location });
}

export function trackFormSubmit(formName: string) {
  trackEvent('form_submit', { formName });
}

export function trackFormAbandonment(formName: string, fieldsFilled: string[]) {
  trackEvent('form_abandonment', { formName, fieldsFilled });
}

export function trackCalculatorUse(values: Record<string, number>) {
  trackEvent('calculator_use', values);
}

export function trackScrollDepth(depth: number) {
  trackEvent('scroll_depth', { depth });
}

export function trackDownload(fileName: string) {
  trackEvent('download', { fileName });
}

export function trackShare(platform: string) {
  trackEvent('share', { platform });
}

export function getAnalytics() {
  const storedEvents = localStorage.getItem('optiaiAnalytics');
  return storedEvents ? JSON.parse(storedEvents) : [];
}

export function clearAnalytics() {
  localStorage.removeItem('optiaiAnalytics');
  events.length = 0;
}

let maxScroll = 0;

export function initScrollTracking() {
  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY;
    const scrollPercent = Math.round((scrollTop / (documentHeight - windowHeight)) * 100);

    if (scrollPercent > maxScroll && scrollPercent % 25 === 0) {
      maxScroll = scrollPercent;
      trackScrollDepth(scrollPercent);
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}
